import {
  MUTATION_ADD_DESIGNS,
  MUTATION_LOAD_PRINT_PLATE_DIMENSIONS,
  MUTATION_SET_FILTERS,
  MUTATION_SET_PRINT_SIDE,
  MUTATION_SET_PRODUCTS,
  MUTATION_UPDATE_FILTERS,
  MUTATION_SEARCH_DESIGNS,
  MUTATION_CLEAR_SEARCH,
  MUTATION_HIDE_NAVIGATION,
  MUTATION_SHOW_NAVIGATION,
  MUTATION_DISABLE_PRODUCT_CHANGE,
  MUTATION_SET_LOCALE
} from './mutation-types';

const enrich = obj => {
  const clone = JSON.parse(JSON.stringify(obj));
  Object.keys(clone).forEach(key => {
    clone[key].selected = false;
  });
  return clone;
};

export default {
  [MUTATION_SET_PRINT_SIDE]: (state, payload) => {
    state.activePrintSide = payload;
  },
  [MUTATION_ADD_DESIGNS]: (state, [designs, position = 0]) => {
    state.designs.splice(position, designs.length, ...designs);
  },
  [MUTATION_SET_PRODUCTS]: (state, products) => {
    state.products = products || [];
  },
  [MUTATION_SET_FILTERS]: (state, filters) => {
    const pimpedFilters = {};

    Object.keys(filters).forEach(value => {
      pimpedFilters[value] = {
        label: `label.${value}`,
        value,
        filters: enrich(filters[value])
      };
    });

    state.filters = pimpedFilters;
  },
  [MUTATION_UPDATE_FILTERS]: (state, updatedFilters) => {
    state.filters = JSON.parse(JSON.stringify(updatedFilters));
  },
  [MUTATION_LOAD_PRINT_PLATE_DIMENSIONS]: (state, dimensions) => {
    state.printplates = dimensions;
  },
  [MUTATION_SEARCH_DESIGNS]: (state, term) => {
    state.searchTerm = term;
  },
  [MUTATION_CLEAR_SEARCH]: state => {
    state.designs = [];
  },
  [MUTATION_DISABLE_PRODUCT_CHANGE]: state => {
    state.productChangeEnabled = false;
  },
  [MUTATION_HIDE_NAVIGATION]: state => {
    state.showNavigation = false;
  },
  [MUTATION_SHOW_NAVIGATION]: state => {
    state.showNavigation = true;
  },
  [MUTATION_SET_LOCALE]: (state, locale) => {
    state.locale = locale;
  }
};
